/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InstanceBulkActionLeadResult
 */
export interface InstanceBulkActionLeadResult {
    /**
     * 
     */
    lead_id: string;
    /**
     * 
     */
    success: boolean;
}

/**
 * Check if a given object implements the InstanceBulkActionLeadResult interface.
 */
export function instanceOfInstanceBulkActionLeadResult(value: object): value is InstanceBulkActionLeadResult {
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    if (!('success' in value) || value['success'] === undefined) return false;
    return true;
}

export function InstanceBulkActionLeadResultFromJSON(json: any): InstanceBulkActionLeadResult {
    return InstanceBulkActionLeadResultFromJSONTyped(json, false);
}

export function InstanceBulkActionLeadResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstanceBulkActionLeadResult {
    if (json == null) {
        return json;
    }
    return {
        
        'lead_id': json['lead_id'],
        'success': json['success'],
    };
}

export function InstanceBulkActionLeadResultToJSON(json: any): InstanceBulkActionLeadResult {
    return InstanceBulkActionLeadResultToJSONTyped(json, false);
}

export function InstanceBulkActionLeadResultToJSONTyped(value?: InstanceBulkActionLeadResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lead_id': value['lead_id'],
        'success': value['success'],
    };
}

